/* Selling Plan Picker — toggles `.is-selected` on the active card and syncs
   the selected plan/variant pair into the product form. */
(function () {
  function init(root) {
    var cards = root.querySelectorAll('[data-spp-card]');
    var form = document.getElementById(root.dataset.productFormId);
    var selectedSellingPlanInput = form && form.querySelector('[data-selected-selling-plan]');
    var selectedReturnToInput = form && form.querySelector('[data-selected-return-to]');
    var variantIdInput = form && form.querySelector('[name="id"]');
    var submitButton = form && form.querySelector('.product-form__submit');
    var submitLabel = submitButton && submitButton.querySelector('[data-submit-label]');
    var onetimeIcon = submitButton && submitButton.querySelector('[data-onetime-icon]');
    var subscriptionIcon = submitButton && submitButton.querySelector('[data-subscription-icon]');
    var defaultVariantId = variantIdInput && variantIdInput.value;
    if (!cards.length) return;

    function syncSelection() {
      var selectedValue = '';
      var selectedVariantId = defaultVariantId;

      cards.forEach(function (card) {
        var input = card.querySelector('[data-selling-plan-option]');
        if (!input) return;
        card.classList.toggle('is-selected', input.checked);
        if (!input.checked) return;

        selectedValue = input.value || '';
        selectedVariantId = input.dataset.sellingPlanVariantId || defaultVariantId;
      });

      if (selectedSellingPlanInput) {
        selectedSellingPlanInput.value = selectedValue;
        selectedSellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (selectedReturnToInput) {
        selectedReturnToInput.value = selectedValue ? '/checkout' : '/cart';
        selectedReturnToInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (variantIdInput && selectedVariantId) {
        variantIdInput.value = selectedVariantId;
        variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (submitLabel) {
        var hasSubscription = Boolean(selectedValue);
        var nextLabel = hasSubscription
          ? submitButton.dataset.subscriptionLabel
          : submitButton.dataset.onetimeLabel;
        if (nextLabel) submitLabel.textContent = nextLabel;
        if (onetimeIcon) onetimeIcon.hidden = hasSubscription;
        if (subscriptionIcon) subscriptionIcon.hidden = !hasSubscription;
      }
    }

    cards.forEach(function (card) {
      var input = card.querySelector('[data-selling-plan-option]');
      if (!input) return;
      input.addEventListener('change', syncSelection);
    });

    syncSelection();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-selling-plan-picker]').forEach(init);
  });

  // Re-init for theme-editor dynamic section refreshes
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-selling-plan-picker]').forEach(init);
  });
})();
